export const hasVisibleColumn = (header, userSearch) => {
    let showCol = true;
    if (header?.visibility) {
        let [field, fieldValue] =
            header?.visibility.indexOf("!=") > -1
                ? header?.visibility?.split("!=")
                : header?.visibility?.split("=");
        let conditionValue = fieldValue?.split(",");
        if (
            (userSearch?.[field] &&
                header?.visibility.indexOf("!=") > -1 &&
                conditionValue.includes(userSearch?.[field])) ||
            (userSearch?.[field] &&
                header?.visibility?.indexOf("!=") == -1 &&
                header?.visibility.indexOf("=") > -1 &&
                !conditionValue.includes(userSearch?.[field])) ||
            (!userSearch?.[field] && !conditionValue.includes("all"))
        ) {
            showCol = false;
        }
    }
    return showCol;
};
